import React, { useEffect } from 'react';
import { Row, Col, Card, Spinner, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMenuChart, selectDays, selectLoading, selectError } from '../../../store/menuChart/menuChartSlice';

const MenuChart = () => {
    const dispatch = useDispatch();
    const days = useSelector(selectDays);
    const loading = useSelector(selectLoading);
    const error = useSelector(selectError);

    useEffect(() => {
        dispatch(fetchMenuChart());
    }, [dispatch]);

    // Define menu types in order
    const menuTypes = ['MORNING SNACK', 'LUNCH', 'AFTERNOON SNACK'];

    return (
        <>
            <Container>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">This Week's Menu </h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                {loading ? (
                                    <div className="text-center p-5">
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                ) : days.length === 0 ? (
                                    <div className="text-center p-5">
                                        <p className="text-muted">No menu data available</p>
                                    </div>
                                ) : (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="table table-bordered align-middle text-center">
                                            <thead>
                                                <tr>
                                                    <th className="bg-primary text-white" style={{ minWidth: 180 }}>Day</th>
                                                    {menuTypes.map((menuType, index) => (
                                                        <th key={index} className="bg-primary text-white" style={{ minWidth: 180 }}>{menuType}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {days.map((day, dayIndex) => (
                                                    <tr key={dayIndex} className={dayIndex % 2 === 0 ? '' : 'bg-light'}>
                                                        <td className="fw-bold text-primary" style={{ minWidth: 180 }}>{day.dayName}</td>
                                                        {menuTypes.map((menuType, typeIndex) => {
                                                            const menuTypeObj = Array.isArray(day.menuTypes)
                                                                ? day.menuTypes.find(mt => mt.menu_type === menuType)
                                                                : null;
                                                            const items = menuTypeObj?.menu_items || [];
                                                            return (
                                                                <td key={typeIndex} style={{ minWidth: 180 }}>
                                                                    {items.length > 0 ? (
                                                                        <ul className="mb-0 ps-3 text-start" style={{ listStyle: 'disc inside' }}>
                                                                            {items.map((item, itemIndex) => (
                                                                                <li key={itemIndex} style={{ color: '#212529', marginBottom: '2px' }}>{item}</li>
                                                                            ))}
                                                                        </ul>
                                                                    ) : (
                                                                        <span className="text-secondary">-</span>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MenuChart;
